package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DocumentCreateRequest(
    @SerialName("school_id") val schoolId: String,
    val title: String,
    val description: String? = null,
    val category: String,
    @SerialName("applicable_to") val applicableTo: String,
    @SerialName("class_targets") val classTargets: List<DocumentClassTargetRequest>? = null,
    @SerialName("file_id") val fileId: String? = null
)

@Serializable
data class DocumentUpdateRequest(
    val title: String? = null,
    val description: String? = null,
    val category: String? = null,
    @SerialName("applicable_to") val applicableTo: String? = null,
    @SerialName("class_targets") val classTargets: List<DocumentClassTargetRequest>? = null,
    @SerialName("file_id") val fileId: String? = null
)

@Serializable
data class DocumentClassTargetRequest(
    @SerialName("class_section_id") val classSectionId: String
)
